/* eslint-disable no-nested-ternary */
/* eslint-disable complexity */
import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { mobileNumberValidatorAU } from "../../../utils/validators/mobile-number-validator";
import { PHONE_COUNTRY_CODE } from "../../../constants/app-constants";
import ErrorIcon from "./images/error-info.svg";
import CrossIcon from "./images/cross-icon.svg";

const DEFAULT_PHONE_LENGTH = 10;

const InputMobile = ({
    onChange = () => {},
    inputRef,
    value = "",
    placeholder = "Mobile Number",
    type = "tel",
    hidePrefixIfNoValuePresent = false,
    showError = true,
    hidePlaceholder = false,
    onFocusCallback = () => { },
    onBlurCallback = () => { },
    onClick = () => {},
    countryCode = PHONE_COUNTRY_CODE,
    maxLength = DEFAULT_PHONE_LENGTH,
    validator = undefined,
    showErrorBorder = false,
    prefixAlwaysVisible = false,
    showErrorMessageIcon = false,
    prefixHidden = false,
    alwaysShowPrefix = false,
    showCrossIcon = false,
    onCrossIconClick = () => {},
    variant = "",
    helperText = "",
    ...rest
}) => {
    const { isFormikForm, form, id, isPadding = false, showErrorOnFocus = false, errorMessage = "" } = rest || {};
    const [isFocused, setIsFocused] = useState(false);
    const [isTouched, setIsTouched] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [error, setError] = useState("");
    const [isPrefixVisible, setIsPrefixVisible] = useState(!prefixHidden);

    const mobileValidator =  validator  || mobileNumberValidatorAU; // defaults to India validator

    const onFocus = (e) => {
        const phone = (e.target.value || "");
        if (phone.length === maxLength || phone.length === 0) {
            setIsFocused(true);
            setIsTouched(true);
        }
        if (!prefixHidden) {setIsPrefixVisible(true);}
        onFocusCallback();
    };
    const onBlur = (e) => {
        setIsFocused(false);
        if (hidePrefixIfNoValuePresent && !e.target.value.length) {
            setIsPrefixVisible(false);
        }
        onBlurCallback(e.target.value);
    };

    const setFormikError = (errMsg) => {
        if (isFormikForm) {
            form.setFieldError(id, errMsg);
            form.setFieldTouched(id, true, false);
        }
    };

    const onChangeHandler = (e) => {
        const number = e.target.value;
        if (!mobileValidator(number)) {
            setFormikError("Invalid mobile number");
            setHasError(true);
            setError(errorMessage || "Invalid mobile number");
        } else {
            setFormikError(null);
            setHasError(false);
            setError("");
        }
        if (isFormikForm) {
            form.setFieldValue(id, e.target.value);
        }
        onChange(e);
    };
    showErrorBorder = isFormikForm ? showError : showErrorBorder;
    return (

        <div>
            <div styleName={ showCrossIcon && value ?
                (isPadding ? `styles.inputShift styles.withPadding styles.withCrossIcon ${variant === "v4" ? "styles.v4" : ""}` : `styles.inputShift styles.withPrefix styles.withCrossIcon ${variant === "v4" ? "styles.v4" : ""}`)
                : (isPadding ? `styles.inputShift styles.withPadding ${variant === "v4" ? "styles.v4" : ""}` : `styles.inputShift styles.withPrefix ${variant === "v4" ? "styles.v4" : ""}`)}>
                <input
                    ref={inputRef}
                    type={type}
                    maxLength={maxLength}
                    name="phone"
                    styleName={showErrorBorder ?
                        "styles.errorBorder" : ""}
                    className="form-control"
                    onFocus={(e) => onFocus(e)}
                    onBlur={(e) => onBlur(e)}
                    onClick={e => onClick(e)}
                    value={value}
                    onChange={onChangeHandler}
                    autoComplete={"off"}
                    placeholder={hidePlaceholder ? placeholder : ""}
                    {...rest}
                // required
                // autoComplete={"off"}
                />
                {(alwaysShowPrefix || value || isFocused || hasError) && isPrefixVisible &&
                    <span id="prefix" styleName={"styles.phoneNumberPrefix"}>
                        +{countryCode}
                    </span>
                }
                {prefixAlwaysVisible &&
                    <span id="prefix" styleName={"styles.phoneNumberPrefix"}>
                        +{countryCode}
                    </span>
                }
                {!hidePlaceholder && <label
                    className={`${(value || isFocused || hasError) ? "customActive" : ""}`}
                    styleName={`${(value || isFocused || hasError) ? "active" : ""}`}>
                    { placeholder }
                </label> }
                {showCrossIcon && value &&
                    <img
                        src={CrossIcon}
                        alt="clear"
                        styleName="styles.crossIcon"
                        onClick={onCrossIconClick}
                    />
                }

            </div>
            {(() => {
                const showingError = (!isFormikForm && showError && hasError && ((isTouched &&
                    !isFocused) || ((value || "").length === maxLength) || (isTouched && showErrorOnFocus)));
                return (
                    <React.Fragment>
                        {showingError && (
                            <small styleName={variant === "v4" ? "styles.v4Error" : "styles.error"}>
                                {showErrorMessageIcon ? <img src={ErrorIcon} alt="error-icon" /> : null}
                                {error}
                            </small>
                        )}
                        {variant === "v4" && !showingError && helperText && (
                            <p styleName="styles.v4HelperText">{helperText}</p>
                        )}
                    </React.Fragment>
                );
            })()}
        </div>
    );
};

InputMobile.propTypes = {
    maxLength: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    inputRef: PropTypes.any,
    onBlurCallback: PropTypes.func,
    showError: PropTypes.bool,
    placeholder: PropTypes.string,
    hidePlaceholder: PropTypes.bool,
    type: PropTypes.string,
    onFocusCallback: PropTypes.func,
    onClick: PropTypes.func,
    hidePrefixIfNoValuePresent: PropTypes.bool,
    countryCode: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    validator: PropTypes.func,
    showErrorBorder: PropTypes.bool,
    prefixAlwaysVisible: PropTypes.bool,
    showErrorMessageIcon: PropTypes.bool,
    prefixHidden: PropTypes.bool,
    alwaysShowPrefix: PropTypes.bool,
    showCrossIcon: PropTypes.bool,
    onCrossIconClick: PropTypes.func,
    variant: PropTypes.string,
    helperText: PropTypes.string
};

export default InputMobile;
